<template>
  <d-tabs card @input="handleTabChange">
    <d-tab title="Visual Editor" active>
      <d-row>
        <d-col cols="12">
          <p>
            The visual editor enables basic editing of the product customization
            object. There are some customizations that cannot be created/edited
            from the visual editor. To accomplish more complex customizations
            the JSON editor should be used.
          </p>
        </d-col>
        <d-col cols="12" xl="3">
          <d-list-group>
            <d-list-group-item
              v-for="group in edit.groups"
              :key="group.id + '_dlksf'"
              class="p-0 list-group-click"
            >
              <div
                @click="() => handleGroupClick(group)"
                class="d-flex justify-content-between flex-row align-items-center h-100 w-100 px-3 py-2"
                :class="
                  !!selectedGroup && selectedGroup.id === group.id
                    ? 'bg-selected'
                    : ''
                "
              >
                <div>{{ group.label }}</div>
                <i class="material-icons">chevron_right</i>
              </div>
            </d-list-group-item>
          </d-list-group>

          <d-button
            @click="handleAddGroupClick"
            theme="primary"
            block
            class="my-2"
            size="sm"
            style="border-radius: 10rem"
          >
            New Group
          </d-button>
        </d-col>
        <d-col cols="12" xl="9" class="selected-group-container">
          <d-card
            v-if="!!selectedGroup"
            class="card-small mb-4 selected-group-card"
            style="border: 0.075rem solid #ddd"
          >
            <!-- Card Header -->
            <d-card-header
              class="border-bottom d-flex flex-row justify-content-between align-items-center"
            >
              <div>
                <h6 class="m-0">{{ selectedGroup.label }}</h6>
                <small class="text-tiny text-light">
                  {{ selectedGroup.id }}
                </small>
              </div>

              <d-button
                size="sm"
                round
                theme="light"
                class="close-card-button"
                @click="handleGroupClick(null)"
              >
                <i class="material-icons text-danger">close</i>
              </d-button>
            </d-card-header>
            <d-card-body>
              <BlurCover v-if="selectedField !== null" classList="d-xl-none" />
              <d-row>
                <!-- Group Label -->
                <d-col xl="4" class="form-group">
                  <label for="group_label">Group Label</label>
                  <d-form-input
                    type="text"
                    id="group_label"
                    v-model="selectedGroup.label"
                  />
                </d-col>

                <!-- Group Receipt Line -->
                <d-col xl="4" class="form-group">
                  <label for="group_receipt_line">Receipt Line</label>
                  <d-form-input
                    type="text"
                    id="group_receipt_line"
                    v-model="selectedGroup.receipt"
                  />
                </d-col>
              </d-row>
              <div class="form-group">
                <!-- Group Fields -->
                <label>Fields</label>

                <d-row>
                  <d-col cols="12" xl="3">
                    <d-list-group class="list-group">
                      <d-list-group-item
                        v-for="field in selectedGroup.fields"
                        :key="field.id + '_534j'"
                        class="p-0 list-group-item list-group-click"
                      >
                        <div
                          @click="() => handleFieldClick(field)"
                          class="d-flex justify-content-between flex-row align-items-center h-100 w-100 px-3 py-2"
                          :class="
                            !!selectedField && selectedField.id === field.id
                              ? 'bg-selected'
                              : ''
                          "
                        >
                          <div>{{ field.label }}</div>
                          <i class="material-icons">chevron_right</i>
                        </div>
                      </d-list-group-item>
                    </d-list-group>

                    <d-button
                      @click="handleAddFieldClick"
                      theme="primary"
                      block
                      class="my-2"
                      size="sm"
                      style="border-radius: 10rem"
                    >
                      New Field
                    </d-button>
                  </d-col>
                  <d-col cols="12" xl="9" class="selected-field-container">
                    <d-card
                      class="selected-field-card"
                      v-if="!!selectedField"
                      style="border: 1px solid #ddd;"
                    >
                      <d-card-header
                        class="border-bottom d-flex flex-row justify-content-between align-items-center"
                      >
                        <div>
                          <h6 class="m-0">{{ selectedField.label }}</h6>
                          <small class="text-tiny text-light">
                            {{ selectedField.id }}
                          </small>
                        </div>
                        <d-button
                          size="sm"
                          round
                          theme="light"
                          class="close-card-button"
                          @click="handleFieldClick(null)"
                        >
                          <i class="material-icons text-danger">close</i>
                        </d-button>
                      </d-card-header>

                      <d-card-body>
                        <BlurCover
                          v-if="selectedChoice !== null"
                          classList="d-xl-none"
                        />
                        <d-row>
                          <!-- Field Label -->
                          <d-col cols="12" xl="4" class="form-group">
                            <label for="field_label">
                              Field Label
                            </label>
                            <d-form-input
                              type="text"
                              id="field_label"
                              v-model="selectedField.label"
                            />
                          </d-col>

                          <!-- Field Receipt Line -->
                          <d-col cols="12" xl="4" class="form-group">
                            <label for="field_receipt_line">
                              Receipt Line
                            </label>
                            <d-form-input
                              type="text"
                              id="field_receipt_line"
                              v-model="selectedField.receipt"
                            />
                          </d-col>

                          <!-- Field Receipt Always -->
                          <d-col cols="12" xl="4" class="form-group">
                            <label for="field_receipt_always">
                              Receipt Always
                            </label>
                            <d-checkbox
                              name="field_receipt_always"
                              v-model="selectedField.receipt_always"
                            />
                          </d-col>
                        </d-row>
                        <div class="form-group">
                          <!-- Field Choices -->
                          <label>
                            Choices
                          </label>
                          <d-row>
                            <d-col cols="12" xl="4">
                              <d-list-group class="list-group">
                                <d-list-group-item
                                  v-for="choice in selectedField.options"
                                  :key="choice.id + '_2i542'"
                                  class="p-0 list-group-item list-group-click"
                                >
                                  <div
                                    @click="() => handleChoiceClick(choice)"
                                    class="d-flex justify-content-between flex-row align-items-center h-100 w-100 px-3 py-2"
                                    :class="
                                      !!selectedChoice &&
                                      selectedChoice.id === choice.id
                                        ? 'bg-selected'
                                        : ''
                                    "
                                  >
                                    <div>
                                      <i
                                        class="material-icons"
                                        style="width: 1rem"
                                        >{{
                                          selectedField.default === choice.id
                                            ? "check"
                                            : ""
                                        }}</i
                                      >
                                      {{ choice.label }}
                                    </div>
                                    <i class="material-icons">
                                      chevron_right
                                    </i>
                                  </div>
                                </d-list-group-item>
                              </d-list-group>

                              <d-button
                                @click="handleAddChoiceClick"
                                theme="primary"
                                block
                                class="my-2"
                                size="sm"
                                style="border-radius: 10rem"
                              >
                                New Choice
                              </d-button>
                            </d-col>
                            <d-col
                              cols="12"
                              xl="8"
                              class="selected-choice-container"
                            >
                              <d-card
                                v-if="!!selectedChoice"
                                style="border: 1px solid #ddd"
                                class="selected-choice-card"
                              >
                                <d-card-header
                                  class="border-bottom d-flex flex-row justify-content-between align-items-center"
                                >
                                  <div>
                                    <h6 class="m-0 p-0">
                                      {{ selectedChoice.label }}
                                    </h6>
                                    <small class="text-tiny text-light">
                                      {{ selectedChoice.id }}
                                    </small>
                                  </div>

                                  <d-button
                                    size="sm"
                                    round
                                    theme="light"
                                    class="close-card-button"
                                    @click="handleChoiceClick(null)"
                                  >
                                    <i class="material-icons text-danger">
                                      close
                                    </i>
                                  </d-button>
                                </d-card-header>
                                <d-card-body>
                                  <d-form>
                                    <d-form-row>
                                      <!-- Choice Label -->
                                      <d-col cols="12" class="form-group">
                                        <label for="choice_label">
                                          Choice Label
                                        </label>
                                        <d-form-input
                                          type="text"
                                          id="choice_label"
                                          v-model="selectedChoice.label"
                                        />
                                      </d-col>

                                      <!-- Choice Receipt Line -->
                                      <d-col cols="12" class="form-group">
                                        <label for="choice_receipt_line">
                                          Receipt Line
                                        </label>
                                        <d-form-input
                                          type="text"
                                          id="choice_receipt_line"
                                          v-model="selectedChoice.receipt"
                                        />
                                      </d-col>

                                      <!-- Choice Price -->
                                      <d-col cols="12" class="form-group">
                                        <label for="choice_price">
                                          Price (In Cents)
                                        </label>
                                        <d-form-input
                                          type="text"
                                          id="choice_price"
                                          v-model="selectedChoice.price"
                                        />
                                      </d-col>
                                      <d-col cols="12" class="form-group">
                                        <label for="choice_default">
                                          Default
                                        </label>
                                        <d-checkbox
                                          name="default"
                                          @change="
                                            handleDefaultChoiceChange(
                                              selectedChoice
                                            )
                                          "
                                          :disabled="
                                            selectedField.default ===
                                              selectedChoice.id
                                          "
                                          :checked="
                                            selectedField.default ===
                                              selectedChoice.id
                                          "
                                        />
                                      </d-col>
                                    </d-form-row>
                                  </d-form>
                                </d-card-body>
                              </d-card>
                            </d-col>
                          </d-row>
                        </div>
                      </d-card-body>
                    </d-card>
                  </d-col>
                </d-row>
              </div>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
      <div
        class="d-flex flex-row justify-content-center align-items-center w-100 mt-5"
      >
        <d-button @click="handleSaveButton">Save</d-button>
      </div>
    </d-tab>
    <d-tab title="JSON">
      <div class="p-3 json-customization-editor">
        <div v-if="currentTab === 1">
          <vueJsonEditor
            v-model="edit"
            mode="view"
            :modes="jsonEditorModes"
            :expandedOnStart="true"
          />
        </div>
      </div>
    </d-tab>
  </d-tabs>
</template>

<script>
import { nanoid } from "nanoid";
import vueJsonEditor from "vue-json-editor";
import BlurCover from "./BlurCover";

const newID = () => {
  return nanoid()
    .substring(0, 6)
    .replace("_", Math.floor(Math.random() * 10));
};

const removeEmpty = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === "object") removeEmpty(obj[key]);
    else if (obj[key] === null || obj[key] === "") delete obj[key];
  });
};

export default {
  components: {
    vueJsonEditor,
    BlurCover
  },
  data() {
    return {
      edit: null,
      editText: null,
      selectedGroup: null,
      selectedField: null,
      selectedChoice: null,
      currentTab: 0,
      jsonEditorModes: ["view", "tree", "code"]
    };
  },
  props: {
    customizations: {
      type: Object
    },
    onSave: {
      type: Function
    }
  },
  created() {
    if (!!this.customizations) {
      this.edit = this.customizations;
    } else {
      this.edit = { groups: [] };
    }
  },
  watch: {
    currentTab() {
      this.selectedGroup = null;
      this.selectedField = null;
      this.selectedChoice = null;
    },
    edit: {
      deep: true
    }
  },
  methods: {
    handleAddChoiceClick(event) {
      event.preventDefault();
      this.selectedField.options.push({
        id: newID(),
        label: "new choice"
      });
    },
    handleAddFieldClick(event) {
      event.preventDefault();
      this.selectedGroup.fields.push({
        id: newID(),
        label: "new field",
        options: []
      });
    },
    handleAddGroupClick(event) {
      event.preventDefault();
      this.edit.groups.push({
        id: newID(),
        label: "new group",
        fields: []
      });
    },
    handleGroupClick(group) {
      this.selectedGroup = group;
      this.selectedField = null;
      this.selectedChoice = null;
    },
    handleFieldClick(field) {
      this.selectedField = field;
      this.selectedChoice = null;
    },
    handleChoiceClick(choice) {
      this.selectedChoice = choice;
    },
    handleSaveButton() {
      let updatedCustomization = JSON.parse(JSON.stringify(this.edit));
      removeEmpty(updatedCustomization);
      !!this.onSave && this.onSave(updatedCustomization);
    },
    handleTabChange(value) {
      this.currentTab = value;
    },
    handleDefaultChoiceChange(choice) {
      this.selectedField.default = choice.id;
    }
  }
};
</script>

<style lang="scss">
@media (max-width: 1200px) {
  .close-card-button {
    margin-top: -8px;
    margin-right: -4px;
    transform: scale(1.25);
  }

  .card-body {
    position: relative;
  }

  .selected-group-container,
  .selected-field-container,
  .selected-choice-container {
    position: absolute;
    top: 0px;
    left: 0px;
    padding: 0;
    z-index: 1000;
  }

  .selected-group-container {
    padding-top: 5rem;
  }

  .selected-group-card,
  .selected-field-card,
  .selected-choice-card {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  }

  .selected-field-card {
    transform: scale(1.025) translateY(-1rem);
  }

  .selected-choice-card {
    transform: scale(1.025) translateY(-1.1rem);
  }
}

.list-group-click {
  &:hover {
    background: rgba(0, 0, 0, 0.04) !important;
    color: #000;
    cursor: pointer;
  }
}

.bg-selected {
  background: rgba(0, 119, 252, 0.1);
  color: rgb(0, 119, 252);
}

.text-tiny {
  font-size: 0.6rem;
  font-weight: 300;
}

.form-group label {
  margin: 0;
  font-weight: 500;
}

.json-customization-editor {
  .jsoneditor {
    border: 0 solid #ccc;
    min-height: 500px;
  }

  .jsoneditor-vue {
    min-height: 500px;
  }

  .div.jsoneditor-outer {
    min-height: 500px;
  }

  .jsoneditor-vue div.jsoneditor-code {
    min-height: 500px;
  }

  div.jsoneditor-menu {
    border-radius: 100rem;
    padding: 4px 1rem;
    background: rgb(0, 119, 252);
    border: 0 solid #ccc;
  }

  div.jsoneditor-tree {
    min-height: 250px;
    overflow: visible !important;
  }

  .jsoneditor-search {
    margin-right: 1rem;
    border-radius: 1rem;
    top: 2px;
  }

  table.jsoneditor-search div.jsoneditor-frame {
    border-radius: 1rem;
    padding: 0 4px;
  }

  div.jsoneditor tr,
  div.jsoneditor th,
  div.jsoneditor td {
    padding: 2px 2px 0 2px;
  }

  div.jsoneditor-contextmenu ul li button {
    padding: 0.25rem 1rem;
  }

  .jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected,
  .jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:focus,
  .jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:hover {
    background: rgba(0, 119, 252, 0.1);
    color: rgb(0, 119, 252);
  }
}
</style>
